import { render, staticRenderFns } from "./IconSmartphone.vue?vue&type=template&id=0673c3e6&scoped=true&"
var script = {}
import style0 from "./IconSmartphone.vue?vue&type=style&index=0&id=0673c3e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0673c3e6",
  null
  
)

export default component.exports